<template >
  <!-- :class="" -->
  <div class="formulier" :class="formData.FormContent[0].class">
    <h2 v-if="showTitle" :class="props.formData.FormContent[0].h2">
      {{ props.formData.FormTitle }}
    </h2>
    <p :class="props.formData.FormContent[0].p">
      {{ props.formData.FormDescription }}
    </p>
    <v-form
      id="form_data_JSON_FORM"
      v-model="formValues"
      @submit.prevent="submit"
      ref="jsonForm"
      v-if="showForm"
    >
      <v-row v-if="props.formData.FormContent && props.formData.FormContent[0]&& props.formData.FormContent[0].schema && props.formData.FormContent[0].schema[0]">
        <v-col
          :cols="formDetail.cols"
          class="py-1"
          v-for="(formDetail, index) in props.formData.FormContent[0].schema[0]
            .properties"
          :key="index"
        >
          <!-- Loop all the entries in the JSON, if a control needs to be display, use corresponding .vue file -->
          <formTextField
            :formDetail="formDetail"
            :model="props.formData.FormContent[0].model[0]"
            :index="index"
            v-if="displayControl(formDetail, 'formTextField')"
          />
          <formTextArea
            :formDetail="formDetail"
            :model="props.formData.FormContent[0].model[0]"
            :index="index"
            v-if="displayControl(formDetail, 'formTextArea')"
          />
          <formNumber
            :formDetail="formDetail"
            :model="props.formData.FormContent[0].model[0]"
            :index="index"
            v-if="displayControl(formDetail, 'formNumber')"
          />
          <formInteger
            :formDetail="formDetail"
            :model="props.formData.FormContent[0].model[0]"
            :index="index"
            v-if="displayControl(formDetail, 'formInteger')"
          />

          <formCheckbox
            :formDetail="formDetail"
            :model="props.formData.FormContent[0].model[0]"
            :index="index"
            v-if="displayControl(formDetail, 'formCheckbox')"
          />
          <formDate
            :formDetail="formDetail"
            :model="props.formData.FormContent[0].model[0]"
            :index="index"
            v-if="displayControl(formDetail, 'formDate')"
          />
          <formSelect
            :formDetail="formDetail"
            :model="props.formData.FormContent[0].model[0]"
            :index="index"
            v-if="displayControl(formDetail, 'formSelect')"
          />
          <formSelectMultiple
            :formDetail="formDetail"
            :model="props.formData.FormContent[0].model[0]"
            :index="index"
            v-if="displayControl(formDetail, 'formSelectMultiple')"
          />
          <formSlider
            :formDetail="formDetail"
            :model="props.formData.FormContent[0].model[0]"
            :index="index"
            v-if="displayControl(formDetail, 'formSlider')"
          />
          <formSwitch
            :formDetail="formDetail"
            :model="props.formData.FormContent[0].model[0]"
            :index="index"
            v-if="displayControl(formDetail, 'formSwitch')"
          />
        </v-col>
      </v-row>

      <v-btn
        :class="formData.FormContent.btn"
        type="submit"
        class="mt-5 text-none"
        size="large"
        >{{ submitButtonText }}</v-btn
      >
    </v-form>
    <v-alert
      v-if="alertText != ''"
      :type="alertType"
      :title="alertTitle"
      :text="alertText"
    ></v-alert>
  </div>
</template>
 
<script setup>
import formTextField from "@/components/JSONForm/formTextField.vue";
import formTextArea from "@/components/JSONForm/formTextArea.vue";
import formNumber from "@/components/JSONForm/formNumber.vue";
import formInteger from "@/components/JSONForm/formInteger.vue";
import formCheckbox from "@/components/JSONForm/formCheckbox.vue";
import formDate from "@/components/JSONForm/formDate.vue";
import formSelect from "@/components/JSONForm/formSelect.vue";
import formSelectMultiple from "@/components/JSONForm/formSelectMultiple.vue";
import formSlider from "@/components/JSONForm/formSlider.vue";
import formSwitch from "@/components/JSONForm/formSwitch.vue";
import { FORM_TYPES } from '@/constants/formTypes';
import HeaderOne from "@/components/Base/headerOne.vue";
const route = useRoute();
const { $apiMethods, $form, $helpers} = useNuxtApp()
// props
const props = defineProps({
  formData: {
    type: Object,
    required: true,
  },
  formType:{
    type:String,
    default: FORM_TYPES.PAGE_FORM,
    required: false,
  },
  showTitle:{
    type:Boolean,
    required:false,
    default:true
  }

});

//Make a computed property that makes a array with entries from formData
const formDataEntries = computed(() =>
  Object.entries(props.formData.FormContent[0].schema[0].properties)
);

//check if the form needs to be filled up with default query params
checkRouteQueryParams();
function checkRouteQueryParams() {
  formDataEntries.value.forEach(([key, value]) => {
    if ($helpers.isset(route.query[key])) {
      props.formData.FormContent[0].model[0][key] = route.query[key];
    }
  });
}

const dataAll = useDataAll();
const jsonForm = ref(null);
const formValues = ref(false);

let recaptchaInstance = $form.init(props.formData);
let showForm = ref(props.formData && props.formData.FormContent != "");
let alertType = ref("success");
let alertTitle = ref("");
let alertText = ref("");

let submitButtonText =
  showForm && props.formData.FormButtonText
    ? props.formData.FormButtonText
    : "OK";
// Submit form
const submit = async () => {
  // Validate form
  const { valid, errors } = await jsonForm.value.validate();

  if (valid) {
    // Get form Fields
    let formData = new FormData(document.getElementById("form_data_JSON_FORM"));
    let data = {};
    // need to convert it before using not with XMLHttpRequest
    for (let [key, val] of formData.entries()) {
      Object.assign(data, { [key]: val });
    }
    // add fromId
    Object.assign(data, { ["FormCode"]: props.formData.FormCode });
    Object.assign(data, { ["Code"]: props.formData.Code });
    Object.assign(data, { ['FormType']: props.formType});
    // Add Recaptcha to data params
    data = await $form.addRecaptchaToPostVars(
      recaptchaInstance,
      data
    );

    showForm.value = false;
    alertType.value = "info";
    alertText.value = dataAll.getStatic(
      "form_busy_processing",
      "Busy, processing the form.."
    );
    await $apiMethods.postApiCall(
        $apiMethods.getApiHostUrl() +
          "/api/" +
          $helpers.getLabelId() +
          "/submitDynamicForm/" +
          dataAll.getLanguage(),
        data
      )
      .then((response) => {
        if (response) {
          if (response.success && response.success === true) {
            alertType.value = "success";
            alertText.value = props.formData.FormSucces
              ? props.formData.FormSucces
              : dataAll.getStatic(
                  "form_send_succesfully",
                  "Form processed succesfully "
                );
          } else {
            alertType.value = "error";
            alertText.value = response.errorString;
          }
        } else {
          alertType.value = "error";
          alertText.value = dataAll.getStatic(
            "form_error",
            "Something went wrong processing the form, please try again later or contact us."
          );
        }
      })
      .catch((err) => {
        console.log(err);
        alertType.value = "error";
          alertText.value = dataAll.getStatic(
            "form_error",
            "Something went wrong processing the form, please try again later or contact us."
          );
      });
  } else {
    alert(dataAll.getStatic("form_correct_errors", "Correct form errors"));
  }
};

function displayControl(formDetail, fieldtype) {
  // Determine which control needs to be used.
  if (formDetail.type == "string") {
    if (formDetail.format == "date" && fieldtype == "formDate") {
      return true;
    } else if (formDetail["enum"] && fieldtype == "formSelect") {
      return true;
    } else if (
      formDetail["x-display"] == "textarea" &&
      fieldtype == "formTextArea"
    ) {
      return true;
    } else if (
      fieldtype == "formTextField" &&
      !formDetail["x-display"] &&
      !formDetail["enum"] &&
      !formDetail.format
    ) {
      return true;
    }
  } else if (formDetail.type == "number") {
    if (fieldtype == "formNumber") {
      return true;
    }
  } else if (formDetail.type == "boolean") {
    if (fieldtype == "formSwitch" && formDetail["x-display"] == "switch") {
      return true;
    } else if (fieldtype == "formCheckbox" && !formDetail["x-display"]) {
      return true;
    }
  } else if (formDetail.type == "integer") {
    if (fieldtype == "formSlider" && formDetail["x-display"] == "slider") {
      return true;
    } else if (fieldtype == "formInteger" && !formDetail["x-display"]) {
      return true;
    }
  } else if (formDetail.type == "array" && fieldtype == "formSelectMultiple") {
    return true;
  }
  return false;
}
</script>

<style scoped>
.formulier .v-btn {
  background-color: rgb(var(--v-theme-contrast)) !important;
  color: rgb(var(--v-theme-primary)) !important;
}
</style>